import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save Inquiry In Progress...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row p-2"
}
const _hoisted_6 = { class: "col-12 offset-lg-1 col-lg-5 row pe-3" }
const _hoisted_7 = { class: "form-group col-12 col-lg-5 pe-lg-2 mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "contact-first-name" }, " Contact First Name ", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_11 = { class: "form-group col-2 pe-lg-2" }
const _hoisted_12 = { for: "contact-middle-initial" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" M.I. ")
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "form-group col-12 col-lg-5" }
const _hoisted_16 = { for: "contact-last-name" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Last Name")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_20 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_21 = { class: "form-group col-12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "contact-phone-number" }, " Contact Phone Number", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_26 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_27 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_28 = {
  key: 0,
  class: "form-group col-12 d-flex flex-column"
}
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, " Branch Name", -1 /* HOISTED */)
const _hoisted_31 = { class: "mt-2 d-flex flex-column" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-3xs fw-normal" }, " Select View Branch History to view or modify the branch associated to this client. Select Add Branch to add a new branch and an associated effective date. ", -1 /* HOISTED */)
const _hoisted_33 = { class: "d-flex mt-2" }
const _hoisted_34 = {
  key: 1,
  class: "form-group col-12"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "agency-location-id" }, [
  /*#__PURE__*/_createTextVNode(" Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Branch", -1 /* HOISTED */)
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_39 = { class: "form-group col-12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "d-inline-block"
}, " Inquiry Date ", -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_42 = { class: "input-group date datepickerInput" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_44 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_45 = { class: "col-12 col-lg-5 row ps-3" }
const _hoisted_46 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_47 = {
  key: 0,
  for: "patient-first-name"
}
const _hoisted_48 = {
  key: 1,
  for: "patient-first-name"
}
const _hoisted_49 = { class: "form-group col-2 pe-lg-2" }
const _hoisted_50 = { for: "patient-middle-initial" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" M.I. ")
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "form-group col-12 col-lg-5" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { for: "patient-last-name" }, " Last Name ", -1 /* HOISTED */)
const _hoisted_55 = { class: "form-group col-12" }
const _hoisted_56 = {
  key: 0,
  for: "phone-number"
}
const _hoisted_57 = {
  key: 1,
  for: "client-phone-number"
}
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "form-group col-12" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { for: "inquiry-comments" }, " Comments ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    fullHeight: false,
    applicationId: _ctx.inquiry.application
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.inquiry.contactFirstName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  name: "contact-first-name",
                  type: "text",
                  placeholder: "Enter Contact First Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inquiry.contactFirstName) = $event)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.contactFirstName.$touch && _ctx.v$.inquiry.contactFirstName.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.inquiry.contactFirstName]
                ]),
                (_ctx.v$.inquiry.contactFirstName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Contact First Name is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, _hoisted_14)), [
                  [_directive_tooltip, { title: `Contact's Middle Initial` }]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "1",
                  name: "contact-middle-initial",
                  type: "text",
                  placeholder: "Enter M.I.",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inquiry.contactMiddleInitial) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.contactMiddleInitial]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _hoisted_17,
                  (_ctx.inquiry.application == _ctx.applicationEnum.AgencyCore)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "/Facility "))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.inquiry.contactLastName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  name: "contact-last-name",
                  type: "text",
                  placeholder: "Enter Contact Last Name",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inquiry.contactLastName) = $event)),
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.contactLastName.$touch && _ctx.v$.inquiry.contactLastName.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.inquiry.contactLastName]
                ]),
                (_ctx.v$.inquiry.contactLastName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Contact Last Name is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("div", {
                  class: _normalizeClass(`${!_ctx.isPhoneNumberInValid ? '' : 'phone-invalid'}`)
                }, [
                  (_ctx.isHomeCareInquiry)
                    ? _withDirectives((_openBlock(), _createBlock(_component_PhoneNumber, {
                        key: 0,
                        id: "contact-phone-number",
                        enableCountry: true,
                        value: _ctx.inquiry.contactPhoneNumbers[0].number,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].number) = $event)),
                        country: _ctx.inquiry.contactPhoneNumbers[0].country,
                        "onUpdate:country": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].country) = $event)),
                        extension: _ctx.inquiry.contactPhoneNumbers[0].extension,
                        "onUpdate:extension": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].extension) = $event)),
                        type: _ctx.inquiry.contactPhoneNumbers[0].type,
                        "onUpdate:type": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].type) = $event)),
                        onBlurredInput: _ctx.v$.inquiry.contactPhoneNumbers[0].number.$touch,
                        class: _normalizeClass(`${!_ctx.v$.inquiry.contactPhoneNumbers[0].number.$error ? '' : 'field-invalid'}`)
                      }, null, 8 /* PROPS */, ["value", "country", "extension", "type", "onBlurredInput", "class"])), [
                        [_directive_number_only]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        id: "contact-phone-number",
                        type: "text",
                        class: _normalizeClass(["form-control phone-number-input", `${!_ctx.v$.inquiry.contactPhoneNumbers[0].number.$error ? '' : 'field-invalid'}`]),
                        value: _ctx.formatPhone(_ctx.inquiry.contactPhoneNumbers[0].number),
                        maxlength: "14",
                        placeholder: "Enter Phone Number",
                        onInput: _cache[9] || (_cache[9] = (event) => _ctx.setContactPhone(event.target.value)),
                        onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.contactPhoneNumbers[0].number.$touch && _ctx.v$.inquiry.contactPhoneNumbers[0].number.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_24)), [
                        [_directive_number_only]
                      ])
                ], 2 /* CLASS */),
                (_ctx.v$.inquiry.contactPhoneNumbers[0].number.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      (
                                    _ctx.v$.inquiry.contactPhoneNumbers[0].number.$errors[0].$message == 'Value is required'
                                )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Contact Phone Number is required."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_27, "10 Digit phone is required."))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              (_ctx.hasTestAgency && _ctx.inquiry.application === _ctx.applicationEnum.HomeCare && _ctx.isEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("span", null, _toDisplayString(_ctx.inquiry.branchName), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-md me-2",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleViewBranchHistory && _ctx.handleViewBranchHistory(...args)))
                        }, " View Branch History "),
                        (_ctx.canAddBranches)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-primary btn-md",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleAddBranch && _ctx.handleAddBranch(...args)))
                            }, " Add Branch "))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _hoisted_35,
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select", `${!_ctx.v$.inquiry.locationId.$error ? '' : 'field-invalid'}`]),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.inquiry.locationId) = $event)),
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedBranch(_ctx.inquiry.locationId))),
                      onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.locationId.$touch && _ctx.v$.inquiry.locationId.$touch(...args)))
                    }, [
                      _hoisted_36,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: branch.id,
                          key: branch.id
                        }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_37))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 34 /* CLASS, HYDRATE_EVENTS */), [
                      [_vModelSelect, _ctx.inquiry.locationId]
                    ]),
                    (_ctx.v$.inquiry.locationId.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Branch is required."))
                      : _createCommentVNode("v-if", true)
                  ])),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _hoisted_41,
                _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives(_createElementVNode("input", {
                        name: "date",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.inquiry.date.$error ? '' : 'field-invalid'}`]),
                        placeholder: "MM/DD/YYYY",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inquiry.date) = $event)),
                        onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.date.$touch && _ctx.v$.inquiry.date.$touch(...args)))
                      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelText, _ctx.inquiry.date]
                      ]),
                      _hoisted_43,
                      (_ctx.v$.inquiry.date.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Date is required."))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                (_ctx.inquiry.application == _ctx.applicationEnum.AgencyCore)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_47, " Patient First Name "))
                  : (_openBlock(), _createElementBlock("label", _hoisted_48, " Client First Name ")),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "50",
                  name: "patient-first-name",
                  type: "text",
                  placeholder: "Enter Patient First Name",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inquiry.firstName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_50, _hoisted_52)), [
                  [_directive_tooltip, { title: `Patient's Middle Initial` }]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "1",
                  name: "patient-middle-initial",
                  type: "text",
                  placeholder: "Enter M.I.",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.inquiry.middleInitial) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.middleInitial]
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "50",
                  name: "patient-last-name",
                  type: "text",
                  placeholder: "Enter Patient Last Name",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.inquiry.lastName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                (_ctx.inquiry.application == _ctx.applicationEnum.AgencyCore)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_56, " Patient Phone Number "))
                  : (_openBlock(), _createElementBlock("label", _hoisted_57, " Client Phone Number ")),
                (_ctx.isHomeCareInquiry)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PhoneNumber, {
                      key: 2,
                      id: "client-phone-number",
                      enableCountry: true,
                      value: _ctx.inquiry.phoneNumbers[0].number,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].number) = $event)),
                      country: _ctx.inquiry.phoneNumbers[0].country,
                      "onUpdate:country": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].country) = $event)),
                      extension: _ctx.inquiry.phoneNumbers[0].extension,
                      "onUpdate:extension": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].extension) = $event)),
                      type: _ctx.inquiry.phoneNumbers[0].type,
                      "onUpdate:type": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].type) = $event))
                    }, null, 8 /* PROPS */, ["value", "country", "extension", "type"])), [
                      [_directive_number_only]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 3,
                      id: "client-phone-number",
                      type: "text",
                      class: "form-control phone-number-input",
                      value: _ctx.formatPhone(_ctx.inquiry.phoneNumbers[0].number),
                      maxlength: "14",
                      placeholder: "Enter Phone Number",
                      onInput: _cache[25] || (_cache[25] = (event) => _ctx.setClientPhone(event.target.value))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_58)), [
                      [_directive_number_only]
                    ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode(_component_CommentInput, {
                  "input-name": "inquiry-comments",
                  placeholder: "Enter Comments",
                  result: _ctx.inquiry.comment,
                  onResultUpdatedAppended: _ctx.resultUpdatedAppended,
                  onResultUpdated: _ctx.resultUpdated,
                  application: _ctx.inquiry.application
                }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "application"])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["applicationId"]))
}